import React from 'react'
import Founder from '../components/Founder'
import AboutUs from '../components/AboutUs'
import Principles from '../components/Principles'
import Activities from '../components/Activities'
import Hero from '../components/Hero'

const Home = () => {
	return (
		<>
			{/* <CarouselWithContent /> */}
			<Hero />
			<Founder />
			<AboutUs />
			<Principles />
			<Activities />
		</>
	)
}

export default Home